var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"families"},_vm._l((_vm.nftMintDict),function(utxos,assetId){return _c('FamilyRow',{key:assetId,attrs:{"family":_vm.nftFamsDict[assetId]},on:{"select":_vm.select}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }